import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";

@Component({
  selector: 'brt-alert-large-footer',
  templateUrl: './alert-large-footer.component.html',
  styleUrls: ['./alert-large-footer.component.scss']
})
export class AlertLargeFooterComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('text') text = "";

}
